module.exports = __webpack_public_path__ + "static/Study-bar-sketch-Mobile-296c03ea59eb4adc35fa6270df6d8aeb.jpg";